// extracted by mini-css-extract-plugin
export default {"Input":"IPInput_Input__Y2ADm","hideArrows":"IPInput_hideArrows__w1JvV"};